// Header.jsx
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import "../tps.css";

const Header = () => {
  const [platform, setPlatform] = useState(null);
  const [loading, setLoading] = useState(false);
  const platformID = localStorage.getItem('platformID');
  const API = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    if (!platformID) {
      alert('Select platform ID');
      return;
    }
    const controller = new AbortController();
    const fetchPlatform = async () => {
      setLoading(true);
      try {
        const res = await axios.get(`${API}/api/header/${platformID}`, { signal: controller.signal });
        setPlatform(res.data[0]);
      } catch (error) {
        if (axios.isCancel(error)) {
          console.log('Fetch canceled');
        } else {
          console.error('Error fetching platform', error);
        }
      } finally {
        setLoading(false);
      }
    };
    fetchPlatform();
    return () => controller.abort();
  }, [platformID, API]);

  return (
    <nav className="navbar py-3 header">
      <div className="container-fluid d-flex justify-content-between align-items-center">
        {/* Left: Home Button */}
        <div>
          <Link to="/" className="btn btn-primary">
            Home
          </Link>
        </div>

        {/* Center: Platform Info */}
        <div className="text-center flex-grow-1">
          {loading ? (
            <span>Loading...</span>
          ) : platform ? (
            <span className="fw-bold mb-0 h4">TPS : {platform.PlatformName}</span>
          ) : (
            <span>Select Platform</span>
          )}
        </div>

        {/* Right: Empty for spacing */}
        <div style={{ width: '75px' }}></div>
      </div>
    </nav>
  );
};

export default Header;
